import React, { useState } from 'react'
import logo from "../../assets/onnize.png"
import { Link } from 'react-router-dom'
import "./user.css"
import { toast } from 'react-toastify'
import { api } from '../../app/Api/ApiSlice'

const ForgotPassword = () => {
    const [email, setEmail] = useState("")
    const [isLoading, setIsLoading] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (!email) {
            return toast.error("Email is required")
        }

        try {
            setIsLoading(true)

            const res = await api.post("/account/forgot-password", {
                email
            })

            toast.success(res.data.message || "Reset link sent to your email")

        } catch (error) {
            const message =
                error.response?.data?.message || "Something went wrong"
            toast.error(message)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="page">
            <div className='login userform'>
                <div className="onnize-logo">
                    <img src={logo} alt="onnize" />
                </div>

                <form onSubmit={handleSubmit}>
                    <h1 className="form-header">Reset Password</h1>

                    <div className="form-input">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id='email'
                            placeholder='Enter your email'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-btn">
                        <button
                            type='submit'
                            className="signup-btn form-btn"
                            disabled={isLoading}
                        >
                            {isLoading ? "Sending..." : "Reset"}
                        </button>
                    </div>
                </form>

                <div className="change-form">
                    <p>Don't have an account?</p>
                    <Link to="/signup" className='form-link'>Signup</Link>
                </div>
            </div>
        </div>
    )
}

export default ForgotPassword